import React from 'react';
import { observable, root } from 'rewire-core';

export function useObservable<T>(obj: T): T {
  const _dispose = React.useRef<() => void>();
  const _result = React.useRef<T>();
  React.useEffect(() => {
    return () => {
      _dispose.current?.();
    };
  }, []);

  if (!_result.current) {
    _result.current = root((dispose) => {
      _dispose.current = dispose;
      return observable(obj as any) as T;
    });
  }

  return _result.current;
}
